export enum ActionTypes {
    FETCH_LOGS = 'logs-module/fetch-logs',
    FETCH_LOGS_FOR_CSV = 'logs-module/fetch-logs-for-csv',
}
